import React from 'react';

// Icon components
const Icons = {
  X: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Sparkles: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
};

function CreditPurchaseModal({ show, onClose, onSelectPlan }) {
  const plans = [
    { 
      id: 'basic', 
      credits: 10, 
      price: 5, 
      perCredit: 0.50,
      savings: null,
      popular: false,
      features: ['10 AI generations', 'Basic support', 'No expiration']
    },
    { 
      id: 'standard', 
      credits: 60, 
      price: 25, 
      perCredit: 0.42,
      savings: 17,
      popular: true,
      features: ['60 AI generations', 'Priority support', 'No expiration', 'Bulk discount']
    },
    { 
      id: 'premium', 
      credits: 130, 
      price: 50, 
      perCredit: 0.38,
      savings: 23,
      popular: false,
      features: ['130 AI generations', 'Priority support', 'No expiration', 'Best value']
    },
  ];

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="credit-modal-title">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title" id="credit-modal-title">
            <Icons.Sparkles /> Buy Credits
          </h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            <Icons.X />
          </button>
        </div>

        <div className="modal-body">
          <p style={{ 
            textAlign: 'center', 
            color: 'var(--text-secondary)', 
            marginBottom: '2rem',
            fontSize: '1.05rem'
          }}>
            Choose a credit package that works for you
          </p>

          <div className="pricing-grid">
            {plans.map((plan) => (
              <div 
                key={plan.id} 
                className={`pricing-card ${plan.popular ? 'popular' : ''}`}
              >
                {plan.popular && (
                  <div className="pricing-badge">Most Popular</div>
                )}
                
                <div className="pricing-credits">{plan.credits}</div>
                <div className="pricing-credits-label">credits</div>
                
                <div className="pricing-price">${plan.price}</div>
                <div className="pricing-per-credit">
                  ${plan.perCredit.toFixed(2)} per credit
                </div>
                
                {plan.savings && (
                  <div className="pricing-savings">
                    Save {plan.savings}%
                  </div>
                )}

                <ul style={{ 
                  listStyle: 'none', 
                  padding: 0, 
                  margin: '1rem 0',
                  textAlign: 'left',
                  fontSize: '0.85rem'
                }}>
                  {plan.features.map((feature, idx) => (
                    <li key={idx} style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '0.5rem',
                      marginBottom: '0.5rem',
                      color: 'var(--text-secondary)'
                    }}>
                      <span style={{ color: 'var(--accent-success)' }}>
                        <Icons.Check />
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button
                  className={`btn-base ${plan.popular ? 'btn-gold' : 'btn-primary'}`}
                  style={{ width: '100%', marginTop: 'auto' }}
                  onClick={() => onSelectPlan(plan.credits)}
                >
                  Buy {plan.credits} Credits
                </button>
              </div>
            ))}
          </div>

          <p style={{ 
            textAlign: 'center', 
            color: 'var(--text-muted)', 
            marginTop: '1.5rem',
            fontSize: '0.85rem'
          }}>
            Secure payment powered by Stripe. Credits never expire.
          </p>
        </div>
      </div>
    </div>
  );
}

export default CreditPurchaseModal;
